export default class Sale {
    constructor(originSale) {
        if (originSale) {
            this.saleAddress = (originSale.saleAddress?originSale.saleAddress:'') + ' ' + (originSale.salePhone?originSale.salePhone:'') // 销方地址 ,
            this.saleAddress=this.saleAddress?this.saleAddress.trim():''
            this.saleBank = (originSale.saleBank?originSale.saleBank:'') + ' ' + (originSale.saleBankAccount?originSale.saleBankAccount:'') // 销方开户银行 ,
            this.saleBank=this.saleBank?this.saleBank.trim():''
            this.saleBankAccount = '' // 销方开户银行账号 ,
            this.saleCreditCode = originSale.saleCreditCode // 销方纳税人信用代码 ,
            this.saleId = originSale.saleId // 销方ID ,
            this.saleName = originSale.saleName // 销方名称 ,
            this.salePhone = '' // 销方电话 ,
            this.isChineseSecurity = originSale.isChineseSecurity
        } else {
            const userStr = localStorage.getItem('user_info')
            const sale = JSON.parse(userStr).sale || JSON.parse(userStr).supplierSale
            const sysUkeyList = JSON.parse(userStr).sysUkeyList[0]
            this.saleAddress = (sale.registerAddress + ' ' + sale.phone).trim() // 销方地址 ,
            this.saleBank = (sale.saleBankAccount && sale.saleBankAccount.bankAndccount).trim() // 销方开户银行 ,
            this.saleBankAccount = '' // 销方开户银行账号 ,
            this.saleCreditCode = sale.saleCreditCode // 销方纳税人信用代码 ,
            this.saleId = sale.saleId || sale.supplierSaleId // 销方ID ,
            this.saleName = sale.saleName // 销方名称 ,
            this.salePhone = '' // 销方电话 ,
            this.isChineseSecurity = sale.isChineseSecurity
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/model/Sale.js